import {emptyByDefault} from '@optimaxdev/analytics/desktop/utils/emptyByDefault/emptyByDefault';
import {getProperty} from '@optimaxdev/utils';

import {EecOptionsType} from 'desktop/types/analyticsTypes';

import {ExtendedProductType} from 'desktop/types/typesProduct';

/**
 * Get frame size for product
 * @param {ExtendedProductType} product - product item
 * @returns {string} - frame size product
 */
export const getFrameSize = (product: ExtendedProductType) => {
    // @ts-expect-error: ExtendedProductType is not compatible
    if (/Little Kids/.test(product?.frame_size_value || '')) {
        return 'T';
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.variant) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return product?.variant;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.size?.labelShort) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return product?.size?.labelShort;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.frame?.size?.shortLabel) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return product?.frame?.size.shortLabel;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    return (product?.frame_size_value || '').slice(0, 1);
};

/**
 * Get variant for product
 * @param {object} product item
 * @param {string} frameSize - frame size product
 * @returns {string} - variant product
 */
// eslint-disable-next-line complexity, max-statements
export const getVariant = (product: ExtendedProductType, frameSize?: string) => {
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.is_contact_lenses) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return `C|${product.contact_lens_type_label || ''}`;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.isContactLenses) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return `C|${product.contactLensTypeLabel || ''}`;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.color_value) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return `${frameSize}|${product.color_value[0] || ''}`;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.variation) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return product.variation || '';
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.color?.label) {
        return `${frameSize}|${getProperty<ExtendedProductType>('color.label')(product)}`;
    }
    // @ts-expect-error: ExtendedProductType is not compatible
    if (product?.contactLensTypeLabel) {
        // @ts-expect-error: ExtendedProductType is not compatible
        return product.name === 'Vista plus' ? `C|${product.contactLensTypeLabel}` : '';
    }
    return frameSize;
};

/**
 * Find price with discount
 * @param {ExtendedProductType} product - Product info
 * @returns {number} Price with discount
 */
// eslint-disable-next-line complexity
export const findPriceWithDiscount = (product: ExtendedProductType): number => {
    return Number(
        ('finalPrice' in product ? product.finalPrice : null) ||
            ('final_price' in product ? product.final_price : null) ||
            ('final_price_with_tax' in product ? product.final_price_with_tax : null) ||
            ('specialPrice' in product ? product.specialPrice : null) ||
            ('product_final_price' in product ? product.product_final_price : null) ||
            0,
    );
};

/**
 * Get product name
 * @param {ExtendedProductType} product - product
 * @returns {string} - product name
 */
export const getName = (product: ExtendedProductType): string => {
    const productName = 'name' in product ? product.name : '';
    const parentName = 'parent_name' in product ? product.parent_name : '';
    const windowName = 'window_name' in product ? product.window_name : '';

    return emptyByDefault(parentName || productName || windowName);
};

/**
 * Get brand name
 * @param {ExtendedProductType} product - product
 * @param {EecOptionsType} options - options
 * @returns {string} - brand name
 */
// eslint-disable-next-line complexity
export const getBrandName = (product: ExtendedProductType, options: EecOptionsType): string => {
    const brandCheck = 'brand' in product && product.brand;

    if (brandCheck && typeof product.brand === 'object') {
        return emptyByDefault(product.brand!.label);
    }

    const brandValue = 'brand_value' in product && product.brand_value;
    const brand = brandCheck && typeof product.brand === 'string' && product.brand;

    return emptyByDefault(brandValue || brand || options.brand);
};
